(function(){
  'use strict';
  const faqs = document.querySelectorAll('.faq__item');
  faqs.forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) faqs.forEach(o => { if (o !== item && o.open) o.open = false; });
    });
  });

  // Show More Reviews — reveals one batch (4 cards) per click
  const moreBtn = document.getElementById('loadMoreReviewsBtn');
  if (moreBtn) {
    let nextBatch = 1;
    const totalBatches = 3;
    moreBtn.addEventListener('click', () => {
      document.querySelectorAll(`.review[data-batch="${nextBatch}"]`).forEach(el => el.classList.add('is-revealed'));
      nextBatch++;
      if (nextBatch > totalBatches) {
        const wrap = document.getElementById('reviewsMoreWrap');
        if (wrap) wrap.style.display = 'none';
      }
    });
  }
})();
